var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.loading)?_c('div',[_c('v-card-text',{staticClass:"pt-2"},[_vm._t("default")],2),_vm._t("actions")],2):_c('div',{staticClass:"tw-h-[200px] tw-flex tw-items-center tw-justify-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }